<template>
  <div ref="component"
       :class="[
         props.class,
         `mb-${props.bottom}`
       ]"
       class="form-component">
    <label class="form-label">
      <span>
        <span class="label-text"
              v-safe-html="props.label" />
        <span v-if="props.text"
              class="text-muted label-description ft-12 m-l-3"
              v-safe-html="props.text" />
        <b v-if="props.must"
           class="must cgRed ft-18 m-l-5">*</b>
      </span>
      <span v-if="$slots.help"
            class="help">
        <slot name="help" />
      </span>
    </label>
    <div :class="[
         'input-group-captcha',
         'input-group',
         'input-group-merge']">
      <el-tooltip
          :visible="active.is.error.enable"
          :popper-class="[
            `is-error is-error-from-captcha`,
            props.parameter.error > 0 ? `messenger error-${props.parameter.error}` : null
          ]"
          placement="top-end">
        <template #content>
        <span @click="props.parameter.error = 0"
              v-safe-html="$t(`${props.prefix}.error.${props.parameter?.error}.subject`)" />
        </template>
        <el-input v-model="props.source[props.name]"
                  @click="isStaticTooltip ? props.parameter.error = 0 : null"
                  @keyup.enter="emit(`submit`)"
                  :placeholder="props.holder"
                  :readonly="props.readonly"
                  :class="[
                    props.variant,
                    props.readonly ? `readonly` : null,
                    props.copy ? `is-copy` : null,
                    $slots.append ? `is-append` : null]"
                  :maxlength="props.maxLength.toString()"
                  type="text"
                  autocomplete="off"
                  :size="props.size" />
      </el-tooltip>
      <span class="input-group-text cursor-pointer captcha">
        <img alt="image"
             @click="onGenerate"
             :src="getCaptcha" />
      </span>
    </div>
  </div>
</template>

<script setup>

import {useStaticTooltip} from "@/hook/useStaticTooltip"

import {
  computed, nextTick,
  reactive, watch
} from "vue"

import {useUtils} from "@/hook/useUtils"

const {
  getUuid
} = useUtils()

/**
 * 參數 - 外部 - 提交
 */
const emit = defineEmits(["submit"])

const props = defineProps({
    must: { type: Boolean, required: false, default: false },
    readonly: { type: Boolean, required: false, default: false },
    label: { type: [String, null], required: false, default: null },
    text: { type: [String, null], required: false, default: null },
    holder: { type: [String, null], required: false, default: null },
    name: { type: String, required: true },
    source: { type: Object, required: true, default: () => { return {} } },
    prefix: { type: String, required: false, default: "" },
    parameter: { type: Object, required: false, default: () => {
    return {
      error: 0
    }
  } },
    error: { type: Array, required: false, default: () => [] },
    class: { type: [String, null], required: false, default: null },
    bottom: { type: Number, required: false, default: 1 },
    copy: { type: Boolean, required: false, default: false },
    variant: { type: [String, null], required: false, default: null },
    size: { type: null, required: false, default: `large` },
    maxLength: { type: Number, required: false, default: parseInt(import.meta.env.VITE_SITE_CAPTCHA_LENGTH) }
  })

const {
  isStaticTooltip
} = useStaticTooltip({
  active: props.parameter,
  prefix: props.prefix
})

/**
 * 參數 - 本地
 */
const active = reactive({
  uuid: getUuid(16, true),
  is: {
    error: {
      enable: false
    }
  }
})

/**
 * 同步 - 驗證碼 - 識別碼 - 至提交內容
 * 後端已改為以 rt 為 key 將答案存入快取（取代 HttpSession），提交時必須一併帶回
 */
const syncKey = () => (props.source).rt = active.uuid

syncKey()

/**
 * 重新產生 - 驗證碼
 */
const onGenerate = () => {
  active.uuid = getUuid(16, true)
  syncKey()
}

/**
 * 獲取 - 驗證碼 - 網址
 */
const getCaptcha = computed(() =>{
  return `${import.meta.env.VITE_BASE_URL}secure/captcha?rt=${active.uuid}`
})

/**
 * 監控 - 錯誤 - 顯示
 * 因為可能會卡到tab的問題, 導致 el-tooltip 的 teleported 出錯
 * 需要經過 nextTicker() 就會正確了
 */
watch(()=>props.parameter.error, async () => {
  if (props.parameter.error > 0) await nextTick()
  active.is.error.enable = isStaticTooltip.value && props.error.includes(props.parameter.error)
})

/**
 * 主動暴露
 */
defineExpose({
  onGenerate
})

</script>

<style scoped lang="scss">
.input-group-captcha {
  position: relative;
  .captcha {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;


  }
}
</style>
